import Hashids from "hashids";
import { logEvent } from "./googleAnalytics/analyticsAdapter.web";
const configJSON = require("../config.js");

interface IUseDetails {
  id: string;
  firstName: string;
  lastName: string;
}

const hashids = new Hashids(configJSON.USER_SLUG_SALT, 6);
const PROFILE_ROUTE = "CustomisableUserProfiles";

const slugify = (str: string) =>
  str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const encodeUserSlug = (
  userId: string,
  firstName: string,
  lastName: string
): string => {
  const encodedId = hashids.encode(userId);
  const slug = `${slugify(firstName)}-${slugify(lastName)}-${encodedId}`;
  return slug;
};

export const decodeUserSlug = (
  slug: string
): { userId: string | null; firstName: string; lastName: string } => {
  const parts = slug.split("-");
  const encodedId = parts.pop();
  const firstName = parts[0] || "";
  const lastName = parts.slice(1).join(" ") || "";

  const decoded = encodedId ? hashids.decode(encodedId) : [];
  const userId = decoded.length > 0 ? String(decoded[0]) : null;

  return { userId, firstName, lastName };
};

export const navigateToUserProfile = (
  navigation: {
    navigate: (
      route: string,
      params: {
        path: { username: string };
      }
    ) => void;
  },
  { id, firstName, lastName }: IUseDetails
) => {
  const userSlug = encodeUserSlug(id, firstName, lastName);
  logEvent('view_profile', { profile_username: userSlug })
  navigation.navigate(PROFILE_ROUTE, {
    path: { username: userSlug },
  });
};
